import React from 'react';
import TAGPhoneDrawer from '../TAGNavigation/TAGPhoneDrawer';
import TAGPickerButtonGroup from './TAGPickerButtonGroup';

var TAGPickerDrawerWrapper = function TAGPickerDrawerWrapper(props) {
  return React.createElement(TAGPhoneDrawer, {
    open: props.open,
    onOpen: props.onOpen,
    onClose: props.onAccept
  }, props.children, React.createElement(TAGPickerButtonGroup, {
    onAccept: props.onAccept,
    onClear: props.onClear,
    onDismiss: props.onDismiss,
    onSetToday: props.onSetToday,
    cancelText: props.cancelText,
    clearable: props.clearable,
    clearText: props.clearText,
    okText: props.okText,
    showTodayButton: props.showTodayButton,
    todayText: props.todayText,
    color: props.color || 'secondary'
  }));
};

export default TAGPickerDrawerWrapper;